// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gWBO","buttons":"styles_buttons__89OuP"};